import React, { useState, useContext, useEffect } from 'react';
import { Box, Chip, Typography } from '@mui/material';
import FormBox from './building_blocks/FormBox';
import ProviderCard from './building_blocks/ProviderCard';
import SearchField from './SearchField';
import { providersPathTo } from '../utils/Api';
import { SearchContext } from '../contexts/SearchContext';
import { useNavigate } from 'react-router-dom';

const Search = () => {
  const [loading, setLoading] = useState(false);
  // const [actualSearchValue, setActualSearchValue] = useState('');
  const { searchResults, setSearchResults, searchTags, setSearchTags, setFromSearch } = useContext(SearchContext);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Busca - TudoPets.app - Marketplace Pet de Curitiba';
  }, []);

  const handleSearchValueChange = (value) => {
    setSearchTags(value);
    if (value.length === 0) {
      setSearchResults([]);
      return;
    }
    setLoading(true);
    const tags = value.map(tag => tag.name).join(',')
    providersPathTo.list({params: {t: tags}}).then((result) => {
      // setActualSearchValue(value);
      setLoading(false);
      setSearchResults(result.data);
    });
  };

  const handleCardClick = (providerId) => {
    setFromSearch(true)
    navigate(`/provider/${providerId}`);
  }

  return (
    <FormBox>
      <div className="search">
        <Box>
          <SearchField onChange={handleSearchValueChange} value={searchTags} />
        </Box>
        {loading ? (
          <p>Carregando...</p>
        ) : (
          <div>
            {/* {searchTags.length > 0 && (
              <>
                <Box display="flex" justifyContent="flex-start" alignItems="center" mt={2} flexWrap="wrap">
                  <Typography sx={{ marginRight: 1 }}>Exibindo resultados para:</Typography>
                  {searchTags.map((tag) => (
                    <Chip key={tag.id} label={tag.name} variant="outlined" sx={{ marginRight: 1 }} />
                  ))}
                </Box>
              </>
            )} */}
            
            <div>
              {searchResults.map((provider) => (
                <ProviderCard key={provider.id} provider={provider} showProducts={true} onCardClick={() => handleCardClick(provider.id)} />
              ))}
            </div>
          </div>
        )}
      </div>
    </FormBox>
  );
};

export default Search;

